export const GET_LIST = 'getList'
export const GET_TIMELINE = 'getTimeline'
export const SET_LIST = 'setList'
export const SET_TIMELINE = 'setTimeline'
export const GET = 'get'
export const SET = 'set'
export const UNSET = 'unset'
